import { usePlatform } from '@/platform/usePlatform';

import { PLATFORM_NAMES } from './format';
import { IssueCodePanel } from './IssueCodePanel';
import { RedeemCodePanel } from './RedeemCodePanel';
import { useLinkedPlatforms } from './useAccountLink';

/**
 * Один баланс и одна история во всех Mini App (ADR-046).
 *
 * Роль площадки — выдаёт она код или принимает — приходит из платформенного
 * слоя: этот компонент не знает, какая площадка какая.
 */
export function LinkedPlatformsSection() {
  const platform = usePlatform();
  const linked = useLinkedPlatforms();

  if (platform.accountLinkRole === null) {
    return null;
  }

  return (
    <section aria-labelledby="linked-platforms-heading" className="px-6 pt-8">
      <h2 id="linked-platforms-heading" className="font-display text-h2 text-text">
        Связанные площадки
      </h2>
      <p className="pt-1 text-sm text-text-2">
        Один баланс и одна история в Telegram, ВКонтакте и Одноклассниках.
      </p>

      {linked.isPending ? (
        <p className="pt-3 text-sm text-text-3">Загружаем…</p>
      ) : linked.isError ? (
        <p role="alert" className="pt-3 text-sm text-danger">
          Не удалось загрузить связанные площадки. Обновите страницу.
        </p>
      ) : (
        <ul className="flex flex-wrap gap-2 pt-3">
          {(linked.data ?? []).map((item) => (
            <li
              key={item}
              className="rounded-full border border-border px-3 py-1 text-sm text-text"
            >
              {PLATFORM_NAMES[item]}
            </li>
          ))}
        </ul>
      )}

      {platform.accountLinkRole === 'issuer' ? <IssueCodePanel /> : <RedeemCodePanel />}
    </section>
  );
}
